var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"layout":"center"}},[_c('h1',[_vm._v("Settings")]),(_vm.currentOrgId && _vm.accessAllowed)?_c('org-settings',{attrs:{"orgId":_vm.currentOrgId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }